export default __webpack_public_path__ + "08e0d5c2511f4b134d2f0b9625b1e31b.svg";